// import './App.css';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import ReactDOM from 'react-dom/client';
// import Home from './pages/Home';
// import Dashboard from './pages/Dashboard';
// import Profile from './pages/Profile';
// import Experience from './pages/Experience';
// import Education from './pages/Education';
// import Portofolio from './pages/Portofolio';
// import Certificate from './pages/Certificate';
// import Publication from './pages/Publication';
// import Login from './pages/Login';
// import Register from './pages/Signup';

// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* <Route path="/" element={<Home />}> */}
//           {/* <Route index element={<Home />} /> */}
//           <Route path="/" element={<Home />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/profile" element={<Profile />} />
//           <Route path="/experience" element={<Experience />} />
//           <Route path="/education" element={<Education />} />
//           <Route path="/portofolio" element={<Portofolio />} />
//           <Route path="/certificate" element={<Certificate />} />
//           <Route path="/publication" element={<Publication />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/register" element={<Register />} />
//         {/* </Route> */}
//       </Routes>
//     </BrowserRouter>
//   );
// }

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);

// App.js
import { BrowserRouter, Route, Routes, Outlet } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
// import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Signup';
import PrivateLayout from './components/PrivateLayout';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Experience from './pages/Experience';
import Education from './pages/Education';
import Portofolio from './pages/Portofolio';
import Certificate from './pages/Certificate';
import Publication from './pages/Publication';
import Editor from './pages/Editor';
import { SessionProvider } from './context/SessionContext';
import WebPage from './pages/WebPage';
import LandingPage from './pages/LandingPage';
import Skill from './pages/Skill';
import Achievement from './pages/Achievement';
import { useState } from 'react';

const ErrorBoundary = ({ children }) => {
  const [error, setError] = useState(null);
  if (error) return <div>Error: {error.message}</div>;
  return children;
};

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          {/* Public Routes */}
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/u/:username" element={<WebPage />} /> {/* Moved outside SessionProvider */}

          {/* Routes dengan SessionProvider tetapi tidak perlu PrivateLayout */}
          <Route element={<SessionProvider><Outlet /></SessionProvider>}>
            <Route path="/editor/:id?" element={<Editor />} />
          </Route>

          {/* Private Routes */}
          <Route
            element={
              <SessionProvider>
                <PrivateLayout />
              </SessionProvider>
            }
          >
            <Route index path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/achievement" element={<Achievement />} />
            <Route path="/education" element={<Education />} />
            <Route path="/portofolio" element={<Portofolio />} />
            <Route path="/certificate" element={<Certificate />} />
            <Route path="/publication" element={<Publication />} />
            <Route path='/skill' element={<Skill />} />
          </Route>
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);